import { render, staticRenderFns } from "./CardNovidades.vue?vue&type=template&id=ec3dc02c"
import script from "./CardNovidades.vue?vue&type=script&lang=js"
export * from "./CardNovidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports